import React from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Images from "../Images";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getCmsData, getQestions } from "../Actions/v1/user";
import { setQuestion, setQuestionDetails } from "../Redux/user.action";
import { useEffect } from "react";
import { useState } from "react";
import config from '../config/config'

function Vac() {
  const dispatch = useDispatch();
  const [cmsData, setCmsData] = useState({
    top: {},
    middle: {},
    bottom: {},
  });

  const getQuestionData = async () => {
    let resp = await getQestions();
    console.log("🚀 ~ getQuestionData ~ resp:", resp);
    if (resp?.status) {
      dispatch(
        setQuestion({
          ...resp?.data?.question,
        })
      );
      dispatch(setQuestionDetails(resp?.data));
    }
  };

  const getCms = async () => {
    let resp = await getCmsData();
    console.log("🚀 ~ getCms ~ resp:", resp);
    if (resp?.status) {
      setCmsData({
        top: resp?.data?.find((val) => val.slug == "homepagetop"),
        middle: resp?.data?.find((val) => val.slug == "homepagemiddle"),
        bottom: resp?.data?.find((val) => val.slug == "homepagebottom"),
      });
    }
  };

  useEffect(() => {
    getQuestionData();
    getCms();
  }, []);

  return (
    <div>
      <div>
        <Header />
        <div className="inner_page">
          <Container className="mt-4">
            <Row className="align-items-center justify-content-between pt-5 pb-5">
              <Col md={6} lg={6} xl={5} xxl={6}>
                <p className="vactitle mb-0">Welcome to</p>
                <h1 className="vacmain fw-600">{cmsData?.top?.title}</h1>
                <p className="vacpara">
                 <div dangerouslySetInnerHTML={{__html : cmsData?.top?.content}}/>
                </p>
                <Link to="/vac-verification">
                  <button className="themebtn themehoverbtn rounded-1 mt-1 py-2 px-4 fw-600">
                    {" "}
                    Start Verification
                  </button>
                </Link>
              </Col>
              <Col md={6} lg={6} xl={5} xxl={5} className="mt-4 mt-md-0">
                <img src={`${config.Back_URL}cms/${cmsData?.top?.images}`} className="img-fluid" alt="vac" />
              </Col>
            </Row>
            <div className="text-center mt-3">
              <p className="vactitle mb-0">Edaface</p>
              <h1 className="mainvac fw-600">Functions of VAC</h1>
              <p className="vacpara">EdaFace VAC Performs Two Functions</p>
            </div>
            <Row className="align-items-center justify-content-between pt-3 pb-5">
              <Col md={6} lg={6} xl={5} xxl={5}>
                <img src={`${config.Back_URL}cms/${cmsData?.middle?.images}`} className="img-fluid" alt="vac" />
              </Col>
              <Col md={6} lg={6} xl={5} xxl={6}>
                <p className="vactitle mb-0">EdaFace </p>
                <h1 className="vacmain fw-600">{cmsData?.middle?.title}</h1>
                <p className="vacpara">
                 <div dangerouslySetInnerHTML={{__html : cmsData?.middle?.content}} />
                </p>
              </Col>
            </Row>
            <Row className="align-items-center justify-content-between pt-5 pb-5">
              <Col md={6} lg={6} xl={5} xxl={6}>
                <p className="vactitle mb-0">EdaFace</p>
                <h1 className="vacmain fw-600">{cmsData?.bottom?.title}</h1>
                <p className="vacpara">
                 <div dangerouslySetInnerHTML={{__html : cmsData?.bottom?.content}} />
                </p>
                <button className="themebtn themehoverbtn rounded-1 mt-1 py-2 px-4 fw-600">
                  {" "}
                  About VAC
                </button>
              </Col>
              <Col md={6} lg={6} xl={5} xxl={5} className="mt-4 mt-md-0">
                <img src={`${config.Back_URL}cms/${cmsData?.bottom?.images}`} className="img-fluid" alt="vac" />
              </Col>
            </Row>
          </Container>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Vac;
